import config from '../../../../../share/config';

/**
 * ソート処理を行う
 * @param {object} self - コンポーネントインスタンス
 * @param {object} column - カラムオブジェクト
 * @param {string} currentSortKey - 現在のソートキー名
 * @param {string} sortDirKey - ソート方向キー名
 */
export function handleSort(self, column, currentSortKey, sortDirKey) {
  if (!column.useSort) return;
  if (self[currentSortKey] === column.name) {
    self[sortDirKey] = self[sortDirKey] === config.ASC ? config.DESC : config.ASC;
  } else {
    self[currentSortKey] = column.name;
    self[sortDirKey] = config.ASC;
  }
}

/**
 * ソートアイコンを取得
 * @param {string} sortDir - ソート方向
 * @returns {string} ソートアイコンHTML
 */
export function getSortIconHtml(sortDir) {
  if (sortDir === config.ASC) {
    return "<span> ▲</span>";
  } else if (sortDir === config.DESC) {
    return "<span> ▼</span>";
  } else {
    return "";
  }
}

/**
 * 配列をソートする
 * @param {Array} items - ソート対象の配列
 * @param {string} sortKey - ソートキー
 * @param {string} sortDir - ソート方向
 * @param {string} excludeVal - 除外する値（オプション）
 * @returns {Array} ソート済み配列
 */
export function sortArray(items, sortKey, sortDir, excludeVal = null) {
  if (sortDir === "") {
    return [...items];
  }
  const sig = sortDir === config.DESC ? -1 : 1;

  return [...items].sort((a, b) => {
    const aVal = a[sortKey];
    const bVal = b[sortKey];

    // 除外値のチェック
    if (excludeVal) {
      const aIsExcluded = aVal === excludeVal;
      const bIsExcluded = bVal === excludeVal;
      if (aIsExcluded !== bIsExcluded) {
        return aIsExcluded ? -1 : 1;
      }
    }

    if (aVal === null || aVal === '') return 1;
    if (bVal === null || bVal === '') return -1;

    return aVal < bVal ? -sig : (aVal > bVal ? sig : 0);
  });
}

/**
 * 配列内のアイテムにハイライトを設定
 * @param {Array} items - ハイライト対象の配列
 * @param {string} key - 比較するキー名
 * @param {*} value - ハイライトする値
 * @param {Array} highlightKeys - ハイライトを設定するキー名の配列
 */
export function setHighlight(items, key, value, highlightKeys) {
  items.forEach(item => {
    if (item[key] === value) {
      item.fieldSpec = {};
      highlightKeys.forEach(highlightKey => {
        item.fieldSpec[highlightKey] = config.LIST_ITEM_HIGHLIGHT;
      });
    } else {
      if (item.fieldSpec) {
        delete item.fieldSpec;
      }
    }
  });
}